module.exports = __webpack_public_path__ + "img/4_l_uk.2a4e5660.svg";